import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ReimbursementPurchaseItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'reimbursementPurchaseItem'
  }

}